import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from '@env/environment';

// Simple auto-connect dans main.ts
if (!environment.production) {
  console.log('🚀 Main.ts - Démarrage de l\'application');
}

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    if (!environment.production) {
      console.log('✅ Application Angular démarrée');
      // Test simple d'auto-connect
      setTimeout(() => {
        console.log('🔄 Test auto-connect depuis main.ts...');
      }, 1000);
    }
  })
  .catch((err) => console.error(err));
